// extracted by mini-css-extract-plugin
export var layout = "layout-module--layout--34MNh";
export var layoutWithMinHeight = "layout-module--layoutWithMinHeight--BcSjT";
export var content = "layout-module--content--gcvSO";
export var homepageNavbarWrapper = "layout-module--homepageNavbarWrapper--fuUBf";